import Pedido from './Pedido';

export default Pedido;